import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux/hooks';
import { planUsageState, getPlanUsage } from '../planUsageSlice';
import moment from 'moment';
import { humanizeBytes, formatDaysLeft } from '../../../shared/helpers/helpers';
import { discoveryState } from '../../discovery/discoverySlice';
import { PlanUsageDisplay } from '../models/PlanUsage.interface';
import { smashPriceformatter } from '../../../components/SmashPrice/SmashPrice';

export const usePlanUsage = (): [boolean, PlanUsageDisplay | null, boolean] => {
    const dispatch = useAppDispatch();
    const { planUsage, isSuccess, isLoading, isError } = useAppSelector(planUsageState);
    const { isSuccess: isSuccessDiscovery } = useAppSelector(discoveryState);

    const [planUsageDisplay, setPlanUsageDisplay] = useState<PlanUsageDisplay | null>(null);

    useEffect(() => {
        if (isError) {
            return;
        }

        if (planUsage) {
            const { dataUsage, dataUsageLimit, endDate, status, plan, price, currency } = planUsage;
            const planUsageDisplay = {
                ...planUsage,
                dataUsageFormat: dataUsageLimit && dataUsage > dataUsageLimit ? humanizeBytes(dataUsage, 20) as string : humanizeBytes(dataUsage) as string,
                dataUsageLimitFormat: dataUsageLimit ? humanizeBytes(dataUsageLimit) as string : 'Unlimited',
                plan: plan as string,
                endDate: moment(endDate).format('MMMM Do YYYY, h:mm:ss a'),
                displayEndDateCount: formatDaysLeft(endDate as string),
                priceFormatted: smashPriceformatter(price, currency),
                status: status as string,
            }
            setPlanUsageDisplay(planUsageDisplay);
            return;
        }

        const fetchData = async () => {
            if (!isLoading && !isSuccess && isSuccessDiscovery) {
                await dispatch(getPlanUsage());
            }
        }

        fetchData();
    }, [isSuccess, isSuccessDiscovery]);

    return [isLoading, planUsageDisplay, isError]
}


